import React, { useState, useMemo } from "react";
import { MDBRow, MDBCol, MDBContainer } from "mdbreact";
import GetAppIcon from "@material-ui/icons/GetApp";
import Button from "@material-ui/core/Button";
import ClipLoader from "react-spinners/ClipLoader";
import BotonCargarArchivo from "./BotonCargarArchivo";
import axios from "axios";
import Slider from "react-slick";
import Swal from "sweetalert2";
import { generarCartaCompromiso } from "../../utils/pdf";

// Importar CSS y JS
import "./FormDocumentacion.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "jquery-mask-plugin/dist/jquery.mask.min";

// Importar Multimedia
import logoufg from "../../assets/images/logo-ufg.png";
import cartaPDF from "../../assets/docs/solicitud-graduacion.pdf";

const FormDocumentacionUpdate = ({
  respDataFormInicial,
  respDataForm,
  respProceso,
  respTitulacion,
  resToken,
  esTecnico,
}) => {
  const [dataFormInical, setDataFormInical] = useState(respDataFormInicial);
  const [loading, setLoading] = useState(true);
  const [arrDocumentosApi, setArrDocumentosApi] = useState([]);
  const [documentosCargados, setDocumentosCargados] = useState([]);
  const [permisoCartaCompromiso, setPermisoCartaCompromiso] = useState(false);
  const [aceptoTerminosCartaJurada, setAceptoTerminosCartaJurada] =
    useState(false);

  const proceso = respProceso;
  const tipoTitulacion = respTitulacion;

  const settings = {
    dots: true,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    centerPadding: "60px",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: true,
          centerPadding: "60px",
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          centerPadding: "60px",
          infinite: false,
        },
      },
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerPadding: "100px",
          infinite: false,
          dots: false,
        },
      },
    ],
  };

  const requestDocumentos = useMemo(
    () => ({
      Proceso: proceso,
      TipoIngreso: dataFormInical.TipoIngreso,
      IdTipoTitulacion: tipoTitulacion,
    }),
    [proceso, dataFormInical.TipoIngreso, tipoTitulacion]
  );

  //Consultar documentos
  React.useEffect(() => {
    const fetchDocumentos = async () => {
      if (!dataFormInical.Carnet) return;

      try {
        // Consultar documentos del proceso
        const documentosResponse = await axios({
          url: process.env.REACT_APP_DOCUMENTACIONAPI + "searchtoken",
          method: "post",
          data: JSON.stringify({
            Token: resToken,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        });

        let documentos = documentosResponse.data.Documentos || [];

        const cartaResponse = await axios({
          url:
            process.env.REACT_APP_DOCUMENTACIONAPI +
            "permite-carta-compromiso/" +
            dataFormInical.Carnet +
            "?ciclo=" +
            process.env.REACT_APP_CICLO,
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (
          cartaResponse.data.permiso === true &&
          (proceso === "NUEVO INGRESO" || proceso === "EQUIVALENCIA")
        ) {
          // Verificar si ya existe un documento con IdDocumentoUnidad = 50
          //   const documentoCJ = documentos.find((d) => d.IdDocumentoUnidad == 50);
          // Agregar documento CARTA COMPROMISO si no existe al inicio de la lista
          //   if (!documentoCJ) {
          //     const cartaCompromisoDoc = {
          //       IdTipoDocumentoGD: 67,
          //       IdDocumentoUnidad: 50,
          //       NombreDocumentoPendiente: "CARTA COMPROMISO",
          //       Documento: null,
          //       IdEstadoDocumento: 2,
          //       Activo: 0,
          //     };
          //     documentos = [cartaCompromisoDoc, ...documentos];
          //   }

          setPermisoCartaCompromiso(true);
        }

        setArrDocumentosApi(documentos);
        setLoading(false);
      } catch (err) {
        setPermisoCartaCompromiso(false);
        setArrDocumentosApi(null);
        setLoading(false);
      }
    };

    fetchDocumentos();
  }, [dataFormInical.Carnet, requestDocumentos, resToken]);

  React.useEffect(() => {
    setDataFormInical(respDataFormInicial);
  }, [respDataFormInicial]);

  const fullName = `${dataFormInical.Nombres} ${dataFormInical.PrimerApellido} ${dataFormInical.SegundoApellido}`;
  const isGraduationProcess = proceso === "PROCESO DE GRADUACIÓN";
  const isMaestria = proceso === "MAESTRÍA";
  const showDownloadSection = isGraduationProcess || isMaestria;

  // Función para manejar cuando se carga un documento
  const handleDocumentoCargado = (nombreDocumento, documentoData) => {
    setDocumentosCargados((prev) => {
      const exists = prev.find(
        (doc) => doc.nombreDocumento === nombreDocumento
      );
      if (exists) {
        // Actualizar documento existente
        return prev.map((doc) =>
          doc.nombreDocumento === nombreDocumento
            ? {
                ...doc,
                ...documentoData,
                nombreDocumento,
                idDocumento: documentoData.IdDocumentoUnidad,
                idTipoDocumentoGD: documentoData.IdTipoDocumentoGD,
              }
            : doc
        );
      } else {
        // Agregar nuevo documento
        return [
          ...prev,
          {
            nombreDocumento,
            ...documentoData,
            idDocumento: documentoData.IdDocumentoUnidad,
            idTipoDocumentoGD: documentoData.IdTipoDocumentoGD,
          },
        ];
      }
    });
  };

  // Función para manejar cuando se elimina un documento
  const handleDocumentoEliminado = (nombreDocumento) => {
    setDocumentosCargados((prev) =>
      prev.filter((doc) => doc.nombreDocumento !== nombreDocumento)
    );
  };

  // Función para generar y descargar la carta compromiso
  const handleDownloadCartaCompromiso = () => {
    try {
      generarCartaCompromiso(proceso, {
        carnet: dataFormInical.Carnet,
        nombres: dataFormInical.Nombres,
        primerApellido: dataFormInical.PrimerApellido,
        segundoApellido: dataFormInical.SegundoApellido,
        carrera: dataFormInical.NombreCarrera,
        documentos: arrDocumentosApi,
      });
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Hubo un problema al generar la declaración jurada",
        icon: "error",
        confirmButtonText: "Reintentar",
      });
    }
  };

  // Función para preparar los datos de la solicitud para actualización de documentos
  const prepareUpdateRequestData = () => {
    // Actualizar arrDocumentosApi con los documentos cargados
    const updatedDocuments = arrDocumentosApi.map((doc) => {
      const documentoCargado = documentosCargados.find(
        (cargado) => cargado.nombreDocumento === doc.NombreDocumentoPendiente
      );

      if (documentoCargado) {
        return {
          ...doc,
          Documento: documentoCargado.Documento,
          Observacion: null,
          IdEstadoDocumento: 6, // Estado para actualización
          Activo: 0, // Se marca como inactivo al actualizar
        };
      }
      return doc;
    });

    return {
      Token: resToken,
      Documentos: updatedDocuments,
    };
  };

  // Función para validar documentos según las reglas del código original
  const validateDocumentsForUpdate = () => {
    let documentosCompletos = 0;

    // Crear una copia actualizada de los documentos con los cargados
    const documentosActualizados = arrDocumentosApi.map((doc) => {
      const documentoCargado = documentosCargados.find(
        (cargado) => cargado.nombreDocumento === doc.NombreDocumentoPendiente
      );

      if (documentoCargado) {
        return {
          ...doc,
          Documento: documentoCargado.Documento,
        };
      }
      return doc;
    });

    // Buscar documentos con datos nulos
    const buscar = documentosActualizados.findIndex(
      (doc) => doc.Documento === null
    );

    // Buscar carta compromiso cargada (implementando la lógica original)
    let buscarCartaCompromiso = documentosActualizados.findIndex(
      (doc) =>
        doc.NombreDocumentoPendiente === "CARTA COMPROMISO" &&
        doc.Documento !== null
    );

    // Aplicar la lógica original: buscarCartaCompromiso = cartaCompromiso
    // En este caso, asumimos que cartaCompromiso es equivalente a permisoCartaCompromiso
    buscarCartaCompromiso = permisoCartaCompromiso ? 1 : buscarCartaCompromiso;

    let otrosDocNull = 0;

    if (buscar === -1) {
      // NO EXISTEN NULOS
      documentosCompletos = 1;
    } else {
      if (buscarCartaCompromiso !== -1) {
        // ENCONTRO CARTA COMPROMISO
        documentosCompletos = 1;
      } else {
        // NO ENCONTRO CARTA COMPROMISO
        documentosActualizados.forEach((doc) => {
          if (
            doc.NombreDocumentoPendiente === "NOTAS DE BACHILLER" ||
            doc.NombreDocumentoPendiente === "COMPROBANTE DE PAGO"
          ) {
            if (doc.Documento === null) {
              documentosCompletos = 1;
            }
          } else if (doc.NombreDocumentoPendiente === "CARTA COMPROMISO") {
            if (doc.Documento === null) {
              documentosCompletos = 1;
            }
          } else {
            if (doc.Documento === null) {
              otrosDocNull++;
            }
          }
        });

        if (otrosDocNull === 0) {
          documentosCompletos = 1;
        } else {
          // Implementar la lógica original de aceptoTerminosCartaJurada
          if (true) {
            documentosCompletos = 1;
          } else {
            documentosCompletos = 0;
          }
        }
      }
    }

    return {
      isValid: documentosCompletos === 1,
      documentosCompletos,
      message: documentosCompletos === 0 ? "Debes adjuntar documentos." : "",
      title: "IMPORTANTE",
    };
  };

  // Función principal de envío de documentos para actualización
  const sendDocs = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Validar documentos
      const validation = validateDocumentsForUpdate();
      console.log("Validation Result:", validation);

      // Verificar que se haya preparado una request para actualización
      const updateRequest = prepareUpdateRequestData();
      // const hasRequestUpdate = updateRequest.length > 0;

      console.log("Prepared Update Request:", updateRequest);

      if (validation.documentosCompletos === 1 && updateRequest) {
        // Realizar envío al servidor usando el endpoint de actualización
        // Enviar como array igual que en el código original
        const response = await axios({
          url: process.env.REACT_APP_DOCUMENTACIONAPI + "updatedocumentos",
          method: "post",
          data: JSON.stringify(updateRequest),
          headers: {
            "Content-Type": "application/json",
          },
        });

        console.log("Update Response:", response);

        // Manejar respuesta exitosa
        if (response.data.Message !== undefined) {
          Swal.fire({
            title: `<strong><b>TOKEN: </b>${resToken}</strong>`,
            icon: "success",
            html: `<p><font size="3">${response.data.Message}</p>`,
            showConfirmButton: false,
            showCloseButton: true,
          }).then(() => {
            window.location.reload(true);
          });
        }
      } else {
        Swal.fire({
          title: "<strong>IMPORTANTE</strong>",
          icon: "info",
          html: '<p><font size="3">Debes adjuntar documentos.</p>',
          showConfirmButton: false,
          showCloseButton: true,
        });
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "<strong>TAMAÑO LIMITE</strong>",
        icon: "warning",
        html: '<p><font size="3">Tus documentos exceden el tamaño limite, te recomendamos que cada documento tengan un tamaño menor de 4 MB</p>',
        showConfirmButton: false,
        showCloseButton: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="wrap-container pt-0">
      <div className="pl-md-5 pr-md-5 content-container">
        <MDBContainer>
          <MDBRow>
            <MDBCol className="text-center">
              <img
                src={logoufg}
                className="img-fluid logo-forms"
                alt="Logo UFG"
              />
              <hr className="hr-logo" />
            </MDBCol>
          </MDBRow>

          <MDBRow>
            <MDBCol className="col-12 mt-4 mt-lg-0">
              <MDBRow>
                <MDBCol className="col-12 col-md-7 mb-4 title-sub-op">
                  <b>Nombre:</b> {fullName}
                </MDBCol>
                <MDBCol className="col-12 col-md-5 mb-4 title-sub-op">
                  <b>Carné:</b> {dataFormInical.Carnet}
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol className="col-12 col-md-7 mb-4 title-sub-op">
                  <b>Carrera:</b> {dataFormInical.NombreCarrera}
                </MDBCol>
              </MDBRow>
            </MDBCol>
          </MDBRow>
          <hr className="hr-60" />
          <MDBRow className="mb-2">
            <MDBCol
              className={
                showDownloadSection || permisoCartaCompromiso
                  ? "col-12 col-md-7 pt-3 pb-3 pe-5 text-justify title-sub-op"
                  : "col-12 pt-3 pb-3 text-justify title-sub-op"
              }
            >
              <div className="fz-e1">{dataFormInical.Message}</div>
              <ul className="list-ob pt-3 fz-e2">
                {arrDocumentosApi &&
                  arrDocumentosApi
                    .filter(
                      (doc) =>
                        doc?.NombreDocumentoPendiente !==
                          "COMPROBANTE DE PAGO" &&
                        doc?.NombreDocumentoPendiente !== "NOTAS DE BACHILLER"
                    )
                    .map((doc, index) => (
                      <li
                        key={`${
                          doc?.IdDocumentoUnidad ||
                          doc?.NombreDocumentoPendiente
                        }-${index}`}
                      >
                        <b>{doc?.NombreDocumentoPendiente}</b>:{" "}
                        {doc?.Observacion}
                      </li>
                    ))}
              </ul>
            </MDBCol>

            {showDownloadSection && (
              <MDBCol className="col-12 offset-md-1 col-lg-4 pt-4 pb-4 pt-lg-0 pb-0 text-center title-sub-op bg-g d-flex align-items-center justify-content-center br-30">
                <div>
                  <label className="title-sub-op-orange mb-0 mt-3 font-16">
                    SOLICITUD DEL TRÁMITE <br />
                    DE GRADUACIÓN
                  </label>
                  <div className="d-flex align-items-center flex-column over-h btn-carta-3 mb-3 mb-lg-0">
                    <a
                      href={cartaPDF}
                      download="Solicitud del trámite de Graduación"
                    >
                      <GetAppIcon style={{ fontSize: 40, color: "#0D3B70" }} />
                    </a>
                    <h6>DESCARGAR AQUÍ</h6>
                  </div>
                </div>
              </MDBCol>
            )}

            {permisoCartaCompromiso && (
              <MDBCol className="col-12 offset-md-1 col-lg-4 pt-4 pb-4 pt-lg-0 pb-0 text-center title-sub-op bg-g d-flex align-items-center justify-content-center br-30">
                <div>
                  <label className="title-sub-op-orange mb-3 mt-3 font-16">
                    DECLARACIÓN JURADA
                  </label>
                  <div className="d-flex align-items-center flex-column over-h btn-carta-3 mb-3 mb-lg-0">
                    <button
                      onClick={handleDownloadCartaCompromiso}
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        padding: "5px",
                        borderRadius: "50%",
                        transition: "background-color 0.3s ease",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.backgroundColor = "#eee")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.backgroundColor = "transparent")
                      }
                      title="Generar y descargar declaración jurada"
                    >
                      <GetAppIcon style={{ fontSize: 40, color: "#0D3B70" }} />
                    </button>
                    <h6>DESCARGAR AQUÍ</h6>
                  </div>
                </div>
              </MDBCol>
            )}
          </MDBRow>
          <MDBRow className="mb-2 mt-5 justify-content-between">
            <MDBCol className="col-md-6">
              <p className="doc-pendientes h5">CARGA TUS DOCUMENTOS</p>
            </MDBCol>
          </MDBRow>
          <hr className="hr-logo" />

          {loading === true ? (
            <div className="wrap-loader">
              <div className="contenedorCenterVertical">
                <ClipLoader size={180} color={"#EF8903"} />
              </div>
            </div>
          ) : (
            <div>
              {arrDocumentosApi != null ? (
                <form action="#" onSubmit={(e) => e.preventDefault()}>
                  <MDBRow>
                    <MDBCol className="col pb-5 pt-5 p-md-4 wrap-slider">
                      <Slider {...settings}>
                        {arrDocumentosApi &&
                          arrDocumentosApi.map((doc) => (
                            <div
                              className="item-slider"
                              key={doc.IdDocumentoUnidad}
                            >
                              <BotonCargarArchivo
                                doc={doc}
                                nombreDocumento={doc.NombreDocumentoPendiente}
                                idDocumento={doc.IdDocumentoUnidad}
                                idTipoDocumentoGD={doc.IdTipoDocumentoGD}
                                onDocumentoCargado={handleDocumentoCargado}
                                onDocumentoEliminado={handleDocumentoEliminado}
                                documentosCargados={documentosCargados}
                              />
                            </div>
                          ))}
                      </Slider>
                    </MDBCol>
                  </MDBRow>
                  <MDBRow>
                    <MDBCol className="p-3 text-right">
                      <Button
                        variant="contained"
                        onClick={sendDocs}
                        className="btn-send-form"
                        disabled={loading || documentosCargados.length === 0}
                      >
                        {loading ? "Enviando..." : `Enviar`}
                      </Button>
                    </MDBCol>
                  </MDBRow>
                </form>
              ) : (
                <div className="document-alert">
                  <h1>
                    Existe un problema con el recurso, comunicate al 2209-2927
                  </h1>
                </div>
              )}
            </div>
          )}
        </MDBContainer>
      </div>
    </div>
  );
};

export default FormDocumentacionUpdate;
